import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=0d178ebe"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d178ebe')) {
      api.createRecord('0d178ebe', component.options)
    } else {
      api.reload('0d178ebe', component.options)
    }
    module.hot.accept("./SystemInfo.vue?vue&type=template&id=0d178ebe", function () {
      api.rerender('0d178ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/SystemInfo.vue"
export default component.exports